import axios from 'axios';
import { Config } from 'config';
import { getAccessToken } from 'lib/Helper/Auth';
import {
  DriveCompany,
  DriveFolder,
  FetchFolderLogsParams,
  FetchFolderLogsResponse,
  CreateDriveFolderAPIResponse,
} from '../Model/Drive';

export function fetchDriveFolders(
  searchParam?: string,
): Promise<{ data: DriveFolder[] }> {
  return axios
    .get(`${Config.API_BASE_URL}intranet/drive/folders`, {
      params: {
        search_param: searchParam?.length ? searchParam : undefined,
      },
      responseType: 'json',
      headers: {
        'Content-Type': 'application/json',
        'access-token': getAccessToken(),
      },
    })
    .then((response) => {
      return {
        data: response.data.data as DriveFolder[],
      };
    });
}

export function createDriveFolder(
  companyName: string,
  regNumber: string,
  companyId?: string,
): Promise<CreateDriveFolderAPIResponse> {
  return axios
    .post(
      `${Config.API_BASE_URL}intranet/drive/folders/create`,
      {
        company_name: companyName,
        reg_number: regNumber,
        company_id: companyId,
      },
      {
        responseType: 'json',
        headers: {
          'Content-Type': 'application/json',
          'access-token': getAccessToken(),
        },
      },
    )
    .then((response) => {
      return response.data as CreateDriveFolderAPIResponse;
    });
}

export function fetchDriveCompanies(
  textSearch?: string,
  excludeWithFolders?: boolean,
): Promise<{ data: DriveCompany[] }> {
  return axios
    .get(`${Config.API_BASE_URL}intranet/drive/companies`, {
      params: {
        company_title: textSearch?.length ? textSearch : undefined,
        exclude_with_folders: excludeWithFolders,
      },
      responseType: 'json',
      headers: {
        'Content-Type': 'application/json',
        'access-token': getAccessToken(),
      },
    })
    .then((response) => {
      return {
        data: response.data.data as DriveCompany[],
      };
    });
}

export function fetchFolderLogs(
  params: FetchFolderLogsParams = {},
): Promise<FetchFolderLogsResponse> {
  const { page = 1, pageSize = 100, searchParam } = params;

  return axios
    .get(`${Config.API_BASE_URL}intranet/drive/folder-logs`, {
      params: {
        page: page,
        page_size: pageSize,
        search_param: searchParam?.length ? searchParam : undefined,
      },
      responseType: 'json',
      headers: {
        'Content-Type': 'application/json',
        'access-token': getAccessToken(),
      },
    })
    .then((response) => {
      return response.data as FetchFolderLogsResponse;
    });
}
